module.exports = __webpack_public_path__ + "static/media/fuselage_image1.fdd979e1.png";